import { useEffect, useState } from 'react';
import { StripeService } from 'lib/apis/StripeServiceNew';

// Order the plans are shown in.
export const SIGNATURE_PLAN_KEYS = ['emerald', 'ruby', 'diamond'];

// The API returns the Signature Collection plans as stripeProduct rows (annual only). The
// `displayName` column says which plan a row is; `row` is kept whole so the checkout can use
// it exactly as it would a standard plan row.
export const toSignaturePlans = (rows) =>
    SIGNATURE_PLAN_KEYS.map((planKey) => {
        const row = (Array.isArray(rows) ? rows : []).find(
            (item) =>
                item.billingFrequency === 'year' &&
                String(item.displayName || '')
                    .trim()
                    .toLowerCase() === planKey
        );
        return row
            ? { planKey, stripePriceId: row.stripePriceId, annualPrice: Number(row.price), row }
            : null;
    }).filter(Boolean);

export const useSignaturePlans = () => {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const response = await StripeService().getStripeProducts('signature');
                if (!cancelled) {
                    setPlans(toSignaturePlans(response?.data));
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err || new Error('Unable to load plans.'));
                }
            } finally {
                if (!cancelled) {
                    setIsLoading(false);
                }
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, []);

    return { plans, isLoading, error };
};
